import Vue from "vue";
import Router from "vue-router";
import store from "@/store/store";
import axios from 'axios';
Vue.use(Router);

// 路由懒加载
//登录
const Login = () => import("@/components/Login");
const ErrorLogin = () => import("@/components/views/business/purpleId/error");
const LoginSelect = () => import("@/components/views/business/purpleId/loginSelect");
//主页
const Home = () => import("@/components/views/Home");
//首页
const ShowView = () => import("@/components/views/common/ShowView");
//入库管理
const Intowarehouse = () =>
  import("@/components/views/business/Intowarehouse/Intowarehouse");
const Intodetail = () =>
  import("@/components/views/business/Intowarehouse/Intodetail");
//出库管理
const Outwarehouse = () =>
  import("@/components/views/business/outwarehouse/Outwarehouse");
const Outdetail = () =>
  import("@/components/views/business/outwarehouse/Outdetail");
//盘点管理
const Singleinventory = () =>
  import("@/components/views/business/Inventory/Singleinventory");
const Moreinventory = () =>
  import("@/components/views/business/Inventory/Moreinventory");
const Inventorydetail = () =>
  import("@/components/views/business/Inventory/Inventorydetail");
const InventoryPushDetail = () =>
  import("@/components/views/business/Inventory/InventoryPushDetail");
//工单管理
const WorkOrder = () =>
  import("@/components/views/business/workorder/WorkOrder");
const WorkOrderDetail = () =>
  import("@/components/views/business/workorder/WorkOrderDetail");
const WorkOrderCreate = () =>
  import("@/components/views/business/workorder/WorkOrderCreate");
const OutboundImport = () =>
  import("@/components/views/business/workorder/OutboundImport");
//移位管理
const Tranwarehouse = () =>
  import("@/components/views/business/translocation/Tranwarehouse");
//仓库管理
const StorageRoom = () => import("@/components/views/basics/StorageRoom");
//货架管理
const GoodsShelves = () => import("@/components/views/basics/GoodsShelves");

//用户
const Userpage = () => import("@/components/views/system/user/Userpage");
// 用户配置
const UserConfiguration = () => import("@/components/views/system/user/userConfiguration");
//资源
const Resource = () => import("@/components/views/system/res/Resource");
//组织
const Organization = () => import("@/components/views/system/org/Organization");
//数据字典
const DataDictionary = () =>
  import("@/components/views/system/dict/DataDictionary");
const DataDictionaryEntry = () =>
  import("@/components/views/system/dict/DataDictionaryEntry");
//员工
const Personnel = () => import("@/components/views/system/per/Personnel");
//角色
const Role = () => import("@/components/views/system/role/Role");
const Assignusers = () => import("@/components/views/system/role/Assignusers");
//监控服务
const ServiceMonitoring = () =>
  import("@/components/views/system/monitor/ServiceMonitoring");
// 数据库
const DatabaseManagement = () =>
  import("@/components/views/system/databases/DatabaseManagement");
// 个人中心
const Personalcenter = () => import("@/components/views/common/Personalcenter");
// 统计报表
const Warehousestock = () => import("@/components/views/report/Warehousestock");
const Inwarehouse = () => import("@/components/views/report/Inwarehouse"); 
const Incomingmation = () => import("@/components/views/report/Incomingmation");
const Outingmation = () => import("@/components/views/report/Outingmation");
const Inandout = () => import("@/components/views/report/Inandout");
const Abnormalstock = () => import("@/components/views/report/Abnormalstock");
const phoneSearch = () => import("@/components/views/report/phoneSearch");

//新增海关管理
const thmodel = () => import('@/components/views/whmodel/thwhmodel.vue')
const WMAP = () => import('@/components/views/whmodel/WMap')
const inventoryReport= () => import('@/components/views/customs/inventoryReport')
const inboundReport= () => import('@/components/views/customs/inboundReport')
const outboundReport= () => import('@/components/views/customs/outboundReport')
const cargoChain= () => import('@/components/views/customs/cargoChain')
const clrReason= () => import('@/components/views/business/clrReason/ClearReason')
const ClearDetail = () =>  import("@/components/views/business/clrReason/ClearDetail");
const customsDepartment = ()=>import("@/components/views/business/department/CustomsDepartment");
//注册标签
const register = () => import("@/components/views/register/index");

//新增机器人模块
const rbpandian = () =>import("@/components/views/robot/rbpandian");
const rbtaskplan = () =>import("@/components/views/robot/rbtaskplan");

//龙门架管理
const cranewhitelist = () =>import("@/components/views/business/crane/cranewhitelist");

const whlimportmange  = () =>import("@/components/views/business/crane/cranewhiteimport");

const createwhldetail = () =>import("@/components/views/business/crane/cranewhldetail");

const cranescanresult = () =>import("@/components/views/business/crane/craneresult");

//系统配置
const ConfigManage = () =>import("@/components/views/system/funconfig/ConfigManage");
//M703解密
const M703Decrypt = () =>import("@/components/views/report/M703Decrypt");
//CON管理
const ConManage = () =>import("@/components/views/business/cons/ConManage");
//agv导入管理
const epcFork = () =>import("@/components/views/business/agv/agvlist");


//一件多票查询
const omquery = () => import("@/components/views/business/onemulti/omreport");
const validationomReport = () => import("@/components/views/business/onemulti/validationomReport");
// STAT报文查询
const StatReport = () => import("@/components/views/report/StatReport");
// 统计报表
const ReportDashboard = () => import("@/components/views/report/ReportDashboard");

//建设中的页面

const transcon= () =>import("@/components/views/thub/THubconstruction");
const exportcon= () =>import("@/components/views/export/exportconstruction");

// 页面刷新时，重新赋值token
if (
  store.getters.gettoken == null ||
  store.getters.gettoken == "" ||
  store.getters.gettoken == undefined
) {
  console.log("--------------------------------------------------token 3....");

  //store.commit("set_token", sessionStorage.getItem("token"));
  store.commit(
    "checkLogin",
    sessionStorage.getItem("isLogin") == null
      ? false
      : sessionStorage.getItem("isLogin")
  );
  store.commit("adduser", sessionStorage.getItem("user"));
}

//
//解决编程式路由往同一地址跳转时会报错的情况
const originalPush = Router.prototype.push;
const originalReplace = Router.prototype.replace;
//push
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
//replace
Router.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch(err => err);
};
const routes = [
  {
    path: "/login",
    name: "Login",
    component: Login,
    

  },
  
  {
    path: "/",
    name: "LoginSelect",
    component: LoginSelect,
    

  },
  {
    path: "/error",
    name: "ErrorLogin",
    component: ErrorLogin,
    

  },
  
  {
    path: "/home",
    name: "Home",
    meta: {
      requiresAuth: true,
      title: "主页"
    },
    component: Home,
    children: [
      {
        path: '/warehousemap',
            name: 'WMAP',
              component: WMAP,
              meta: {
                title: '仓库概览模型'
              }
      },
      
      {
        path: "/export",
        name: "exportcon",
        component: exportcon,
        meta: {
          title: "出口"
        }
      },
      {
        path: "/transcon",
        name: "transcon",
        component: transcon,
        meta: {
          title: "中转集拼"
        }
      },

      {
        path: '/3d',
        name: 'd3Model',
        component: thmodel,
        meta: {
          title: 'F库详情'
        }
      },
      {
        path: '/customsivreport',
        name: 'customsivreport',
        component: inventoryReport,
        meta: {
          title: '海关查扣库库存查询报表'
        }
      },
      {
        path: '/customsinreport',
        name: 'customsinreport',
        component: inboundReport,
        meta: {
          title: '海关查扣库入库查询报表'
        }},
        {
          path: '/customsclrreport',
          name: 'customsclrreport',
          component: outboundReport,
          meta: {
            title: '海关查扣库出库查询报表'
          }
        },
        {
          path: '/customscargo',
          name: 'customscargo',
          component: cargoChain,
          meta: {
            title: '查扣库追踪查询报表'
          }
        },
        {
          path: '/clrReason',
          name: 'clrReason',
          component: clrReason,
          meta: {
            title: '出库原因导入'
          }
        },
        {
          path: "/outclrdetail/:id/",
          name: "outclrdetail",
          component: ClearDetail,
          meta: {
            title: "出库原因详情"
          }
        },
        {
          path: '/waybillDep',
          name: 'waybillDep',
          component: customsDepartment,
          meta: {
            title: '运单科室导入'
          }
        },

        
      {
        path: "/personal",
        redirect: "/personalcenter",
        meta: {
          title: "个人中心"
        }
      },
      {
        path: "/intowarehouse",
        name: "Intowarehouse",
        component: Intowarehouse,
        meta: {
          title: "入库管理"
        }
      },
      {
        path: "/intodetail/:billNumber/:id",
        name: "Intodetail",
        component: Intodetail,
        meta: {
          title: "运单号详情"
        }
      },
      {
        path: "/outwarehouse",
        name: "Outwarehouse",
        component: Outwarehouse,
        meta: {
          title: "出库管理"
        }
      },
      {
        path: "/outdetail/:billNumber/:id",
        name: "Outdetail",
        component: Outdetail,
        meta: {
          title: "出库单详情"
        }
      },
      {
        path: "/singleinventory",
        name: "Singleinventory",
        component: Singleinventory,
        meta: {
          title: "货架盘点"
        }
      },
      {
        path: "/moreinventory",
        name: "Moreinventory",
        component: Moreinventory,
        meta: {
          title: "笼统盘点"
        }
      },
      {
        path: "/rbpandian",
        name: "rbpandian",
        component: rbpandian,
        meta: {
          title: "机器人盘点计划"
        }
      },
      {
        path: "/rbtaskplan",
        name: "rbtaskplan",
        component: rbtaskplan,
        meta: {
          title: "机器人盘点任务计划"
        }
      },
      {
        path: "/cranewhitelist",
        name: "cranewhitelist",
        component: cranewhitelist,
        meta: {
          title: "龙门架白名单"
        }
      },
      
      {
        path: "/whlimportmange",
        name: "whlimportmange",
        component: whlimportmange,
        meta: {
          title: "龙门架白名单"
        }
      },
      {
        path: "/createwhldetail/:id",
        name: "createwhldetail",
        component: createwhldetail,
        meta: {
          title: "龙门架白名单详情"
        }
      },
      {
        path: "/cranescanresult",
        name: "cranescanresult",
        component: cranescanresult,
        meta: {
          title: "龙门架扫描结果管理"
        }
      },
      {
        path: "/epcFork",
        name: "epcFork",
        component: epcFork,
        meta: {
          title: "AGV导入"
        }
      },
      {
        path: "/configManage",
        name: "ConfigManage",
        component: ConfigManage,
        meta: { title: "系统配置" }
      },
      {
        path: "/m703Decrypt",
        name: "M703Decrypt",
        component: M703Decrypt,
        meta: { title: "M703敏感数据解密" }
      },
      {
        path: "/conManage",
        name: "ConManage",
        component: ConManage,
        meta: { title: "CON管理" }
      },


      {
        path: "/inventorydetail/:inventoryNumber",
        name: "Inventorydetail",
        component: Inventorydetail,
        meta: {
          title: "盘点单详情"
        }
      },
      {
        path: "/inventoryPushDetail/:inventoryNumber",
        name: "InventoryPushDetail",
        component: InventoryPushDetail,
        meta: {
          title: "盘点数据推送详情"
        }
      },
      {
        path: "/workorder",
        name: "WorkOrder",
        component: WorkOrder,
        meta: {
          title: "工单管理"
        }
      },
      {
        path: "/workorderdetail/:id",
        name: "WorkOrderDetail",
        component: WorkOrderDetail,
        meta: {
          title: "工单详情"
        }
      },
      {
        path: "/workorder/create",
        name: "WorkOrderCreate",
        component: WorkOrderCreate,
        meta: {
          title: "下工单"
        }
      },
      {
        path: "/outbound/import",
        name: "OutboundImport",
        component: OutboundImport,
        meta: {
          title: "导入出库单"
        }
      },
      {
        path: "/storageRoom",
        name: "StorageRoom",
        component: StorageRoom,
        meta: {
          title: "仓库管理"
        }
      },
      {
        path: "/goodsShelves",
        name: "GoodsShelves",
        component: GoodsShelves,
        meta: {
          title: "货架管理"
        }
      },
      {
        path: "/tranwarehouse",
        name: "Tranwarehouse",
        component: Tranwarehouse,
        meta: {
          title: "移位管理"
        }
      },
      {
        path: "/userpage",
        name: "Userpage",
        component: Userpage,
        meta: {
          title: "用户管理"
        }
      },
      {
        path: "/UserConfiguration",
        name: "UserConfiguration",
        component: UserConfiguration,
        meta: {
          title: "用户配置"
        }
      },
      {
        path: "/resource",
        name: "Resource",
        component: Resource,
        meta: {
          title: "资源管理"
        }
      },
      {
        path: "/organization",
        name: "Organization",
        component: Organization,
        meta: {
          title: "组织机构"
        }
      },
      {
        path: "/dataDictionary",
        name: "DataDictionary",
        component: DataDictionary,
        meta: {
          title: "数据字典"
        }
      },
      {
        path: "/dataDictionaryEntry/:id/:name",
        name: "DataDictionaryEntry",
        component: DataDictionaryEntry,
        meta: {
          title: "数据字典项"
        }
      },
      {
        path: "/personnel",
        name: "Personnel",
        component: Personnel,
        meta: {
          title: "员工管理"
        }
      },
      {
        path: "/role",
        name: "Role",
        component: Role,
        meta: {
          title: "角色管理"
        }
      },
      {
        path: "/assignusers/:id",
        name: "Assignusers",
        component: Assignusers,
        meta: {
          title: "分配用户"
        }
      },
      {
        path: "/showView",
        name: "ShowView",
        component: ShowView
      },
      {
        path: "/serviceMonitoring",
        name: "ServiceMonitoring",
        component: ServiceMonitoring,
        meta: {
          title: "服务监控"
        }
      },
      {
        path: "/databaseManagement",
        name: "DatabaseManagement",
        component: DatabaseManagement,
        meta: {
          title: "数据库管理"
        }
      },
      {
        path: "/personalcenter",
        name: "Personalcenter",
        component: Personalcenter,
        meta: {
          title: "个人中心"
        }
      },
      {
        path: "/warehousestock",
        name: "Warehousestock",
        component: Warehousestock,
        meta: {
          title: "库存明细"
        }
      },
      {
        path: "/incomingmation",
        name: "Incomingmation",
        component: Incomingmation,
        meta: {
          title: "入库信息统计"
        }
      },
      {
        path: "/Inwarehouse",
        name: "Inwarehouse",
        component: Inwarehouse,
        meta: {
          title: "到站绑定报表"
        }
      },
      
      {
        path: "/omquery",
        name: "omquery",
        component: omquery,
        meta: {
          title: "一票多件M704报文查询"
        }
      },
      {
        path: "/validationomReport",
        name: "validationomReport",
        component: validationomReport,
        meta: {
          title: "一票多件报表"
        }
      },
      {
        path: "/mstat",
        name: "StatReport",
        component: StatReport,
        meta: {
          title: "STAT报文查询"
        }
      },
      {
        path: "/reportDashboard",
        name: "ReportDashboard",
        component: ReportDashboard,
        meta: {
          title: "统计报表"
        }
      },
      {
        path: "/outingmation",
        name: "Outingmation",
        component: Outingmation,
        meta: {
          title: "出库信息统计"
        }
      },
      {
        path: "/inandout",
        name: "Inandout",
        component: Inandout,
        meta: {
          title: "出入库统计"
        }
      },
      {
        path: "/abnormalstock",
        name: "Abnormalstock",
        component: Abnormalstock,
        meta: {
          title: "库存异常"
        }
      },
      {
        path: "/phoneSearch",
        name: "phoneSearch",
        component: phoneSearch,
        meta: {
          title: "手持机查找"
        }
      },
      {
        path: "/register",
        name: "register",
        component: register,
        meta: {
          title: "标签注册"
        }
      }
    ]
  }
];

const router = new Router({
  mode: "history",
  // base: '/beijing-asset/',
  routes: routes
});

// 设置路由守卫，在进页面之前，判断有token，才进入页面，否则返回登录页面
// if (store.getters.get_tokesn()) {
//   store.commit("set_token", token);
// }

router.beforeEach(async (to, from, next) => {
  
  if (to.meta.requiresAuth) {
    
    // 如果 store 中已有登录标志，直接放行
    console.log("-------------login succuss..*******************. 5.4",store.state.isLogin);
    if (store.state.isLogin) {
      
      next();
      return;
    }
    
    // 否则尝试向后端验证当前会话是否有效
   
    try {

      const res = await axios.post('/apis/system/currentUser',{}, {withCredentials: true,
        headers: {
          'sysTime': new Date().getTime() // 在这里显式添加 Header
        } });
          


          if (res.data.statusCode === '200') {
            // 恢复用户信息和登录状态
            console.log("-------------login succuss..*******************. 6");
            console.log(res.data);
            store.commit('checkLogin', true);
            store.commit('adduser', JSON.stringify(res.data.result));
            next();
          } else {
            // 未登录，跳转到 SAML 登录
            console.log("-------------login succuss..*******************. 6.6");
  
            const msg = res.data.message || '登录已过期';
            window.location.replace('/?reason=' + encodeURIComponent(msg));
          }
          }catch (error) {

            // 请求失败，视为未登录
            console.log("-------------login succuss..*******************. 6.9");
            console.error("请求发生错误:", error);
  
            const msg = '登录已过期';
            window.location.replace('/?reason=' + encodeURIComponent(msg));
            }
    }
    else {
    next();
  }}
);
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js